let _initProto, _initClass, _init_toastId, _init_extra_toastId, _init_title, _init_extra_title, _init_description, _init_extra_description, _init_variant, _init_extra_variant, _init_duration, _init_extra_duration, _init_dismissible, _init_extra_dismissible, _init_closeButton, _init_extra_closeButton, _init_actionLabel, _init_extra_actionLabel, _init_position, _init_extra_position, _init_markedDelete, _init_extra_markedDelete, _init_toastTarget, _init_extra_toastTarget;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { RadiantElement, bound, customElement, onEvent, onUpdated, prop, query } from "@ecopages/radiant";
import { DEFAULT_TOAST_POSITION, TOAST_EXIT_MS, TOAST_LIFETIME, TOAST_SWIPE_THRESHOLD, splitToastPosition } from "./toast-context";
import { toastState } from "./toast-state";
const toastDeadlines = /* @__PURE__ */new Map();
const toastRemainingMs = /* @__PURE__ */new Map();
function deadlineKey(id) {
  return String(id);
}
function clearToastDeadline(id) {
  if (id === "") return;
  const key = deadlineKey(id);
  toastDeadlines.delete(key);
  toastRemainingMs.delete(key);
}
export function resetToastDeadlines() {
  toastDeadlines.clear();
  toastRemainingMs.clear();
}
function freezeToastDeadline(id) {
  if (id === "") return;
  const key = deadlineKey(id);
  const deadline = toastDeadlines.get(key);
  if (deadline == null) return;
  toastRemainingMs.set(key, Math.max(0, deadline - Date.now()));
  toastDeadlines.delete(key);
}
let _RuiToast;
class RuiToast extends RadiantElement {
  static {
    ({
      e: [_init_toastId, _init_extra_toastId, _init_title, _init_extra_title, _init_description, _init_extra_description, _init_variant, _init_extra_variant, _init_duration, _init_extra_duration, _init_dismissible, _init_extra_dismissible, _init_closeButton, _init_extra_closeButton, _init_actionLabel, _init_extra_actionLabel, _init_position, _init_extra_position, _init_markedDelete, _init_extra_markedDelete, _init_toastTarget, _init_extra_toastTarget, _initProto],
      c: [_RuiToast, _initClass]
    } = _applyDecs(this, [customElement("rui-toast")], [[prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "toastId"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "title"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "description"], [prop({
      type: String,
      reflect: true,
      defaultValue: "default"
    }), 0, "variant"], [prop({
      type: Number,
      defaultValue: TOAST_LIFETIME
    }), 0, "duration"], [prop({
      type: Boolean,
      defaultValue: true
    }), 0, "dismissible"], [prop({
      type: Boolean,
      defaultValue: false
    }), 0, "closeButton"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "actionLabel"], [prop({
      type: String,
      defaultValue: DEFAULT_TOAST_POSITION
    }), 0, "position"], [prop({
      type: Boolean,
      defaultValue: false
    }), 0, "markedDelete"], [query({
      ref: "toast"
    }), 0, "toastTarget"], [onUpdated(["title", "description", "variant", "actionLabel", "closeButton"]), 2, "onContentUpdated"], [onUpdated("position"), 2, "onPositionUpdated"], [onUpdated("duration"), 2, "onDurationUpdated"], [onUpdated("markedDelete"), 2, "onMarkedDeleteUpdated"], [bound, 2, "onPointerDown"], [bound, 2, "onPointerMove"], [bound, 2, "onPointerUp"], [onEvent({
      selector: "[data-toast-close]",
      type: "click"
    }), 2, "onCloseClick"], [onEvent({
      selector: "[data-toast-action]",
      type: "click"
    }), 2, "onActionClick"]], 0, void 0, RadiantElement));
  }
  toastId = (_initProto(this), _init_toastId(this));
  title = (_init_extra_toastId(this), _init_title(this));
  description = (_init_extra_title(this), _init_description(this));
  variant = (_init_extra_description(this), _init_variant(this));
  duration = (_init_extra_variant(this), _init_duration(this));
  dismissible = (_init_extra_duration(this), _init_dismissible(this));
  closeButton = (_init_extra_dismissible(this), _init_closeButton(this));
  actionLabel = (_init_extra_closeButton(this), _init_actionLabel(this));
  position = (_init_extra_actionLabel(this), _init_position(this));
  markedDelete = (_init_extra_position(this), _init_markedDelete(this));
  toastTarget = (_init_extra_markedDelete(this), _init_toastTarget(this));
  mounted = (_init_extra_toastTarget(this), false);
  removed = false;
  swiping = false;
  swipeOut = false;
  swipeAxis = null;
  swipeOutDirection = null;
  held = false;
  timerReady = false;
  timeoutId = null;
  pointerStart = null;
  dragStartTime = null;
  exitTimer = null;
  /**
   * Wire pointer listeners, then announce mount after paint so enter CSS can run.
   *
   * @remarks
   * `mounted` stays true across disconnect so list remounts skip the enter
   * animation (avoids an opacity flicker when siblings update). Timer state is
   * still reset on disconnect and restarted on reconnect / first paint.
   */
  connectedCallback() {
    super.connectedCallback();
    const isReconnect = this.mounted;
    this.addEventListener("pointerdown", this.onPointerDown);
    this.addEventListener("pointermove", this.onPointerMove);
    this.addEventListener("pointerup", this.onPointerUp);
    this.addEventListener("pointercancel", this.onPointerUp);
    if (isReconnect) {
      this.timerReady = true;
      this.syncDomState();
      this.dispatchEvent(new CustomEvent("rui-toast-mounted", {
        bubbles: true
      }));
      if (!this.held && !this.removed) {
        this.startTimer();
      }
      return;
    }
    this.timerReady = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.mounted = true;
        this.timerReady = true;
        this.syncDomState();
        this.dispatchEvent(new CustomEvent("rui-toast-mounted", {
          bubbles: true
        }));
        if (!this.held && !this.removed) {
          this.startTimer();
        }
      });
    });
    this.syncDomState();
  }
  /**
   * Clear timers on unmount. Only purge shared state when this instance was exiting —
   * overflow toasts are intentionally unmounted while still queued.
   */
  disconnectedCallback() {
    this.clearTimer();
    if (this.exitTimer) {
      clearTimeout(this.exitTimer);
      this.exitTimer = null;
    }
    const id = this.resolvedId;
    if (id !== "" && this.removed) {
      toastState.remove(id);
    }
    this.held = false;
    this.timerReady = false;
    this.removeEventListener("pointerdown", this.onPointerDown);
    this.removeEventListener("pointermove", this.onPointerMove);
    this.removeEventListener("pointerup", this.onPointerUp);
    this.removeEventListener("pointercancel", this.onPointerUp);
    super.disconnectedCallback();
  }
  onContentUpdated() {
    this.requestUpdate();
  }
  onPositionUpdated() {
    this.syncDomState();
  }
  /**
   * Hold or release auto-dismiss (toaster-controlled on stack hover).
   *
   * @remarks
   * Pause freezes leftover ms so wall-clock time during hover does not consume
   * the lifetime. Resume rebuilds the deadline from that remainder.
   */
  setPaused(paused) {
    if (this.held === paused) {
      if (!paused && this.timerReady && this.mounted && !this.removed && !this.timeoutId) {
        this.startTimer();
      }
      return;
    }
    this.held = paused;
    if (!this.timerReady || !this.mounted || this.removed) return;
    if (paused || document.hidden) {
      freezeToastDeadline(this.resolvedId);
      this.clearTimer();
    } else {
      this.startTimer();
    }
  }
  onDurationUpdated() {
    if (!this.timerReady || !this.mounted || this.removed || this.held) return;
    clearToastDeadline(this.resolvedId);
    this.startTimer();
  }
  onMarkedDeleteUpdated() {
    if (this.markedDelete && !this.removed) {
      this.beginRemove();
    }
  }
  get resolvedId() {
    const raw = this.toastId;
    if (raw == null || raw === "") return "";
    const asNumber = Number(raw);
    return Number.isFinite(asNumber) && String(asNumber) === raw ? asNumber : raw;
  }
  clearTimer() {
    if (this.timeoutId) clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }
  /**
   * Countdown to the toast's dismiss deadline.
   *
   * @remarks
   * Deadlines live in a module map keyed by toast id so list remounts (sibling
   * dismiss / re-render) resume leftover time instead of restarting `duration`.
   * Hover pause stores remaining ms separately and rebuilds the deadline on resume.
   */
  startTimer() {
    if (this.held || this.removed || document.hidden) return;
    if (this.duration === Number.POSITIVE_INFINITY || this.variant === "loading") return;
    if (this.duration <= 0) {
      this.beginRemove();
      return;
    }
    const id = this.resolvedId;
    const key = deadlineKey(id);
    const now = Date.now();
    let remaining = toastRemainingMs.get(key);
    toastRemainingMs.delete(key);
    if (remaining == null) {
      const deadline = toastDeadlines.get(key);
      remaining = deadline != null ? deadline - now : this.duration;
    }
    if (remaining <= 0) {
      clearToastDeadline(id);
      this.beginRemove();
      return;
    }
    toastDeadlines.set(key, now + remaining);
    this.clearTimer();
    this.timeoutId = setTimeout(() => {
      clearToastDeadline(id);
      this.beginRemove();
    }, remaining);
  }
  beginRemove() {
    if (this.removed) return;
    this.removed = true;
    this.clearTimer();
    clearToastDeadline(this.resolvedId);
    this.syncDomState();
    if (!this.markedDelete) {
      toastState.dismiss(this.resolvedId);
    }
    this.exitTimer = setTimeout(() => {
      this.exitTimer = null;
      toastState.remove(this.resolvedId);
    }, TOAST_EXIT_MS);
  }
  onPointerDown(event) {
    if (!this.dismissible || this.variant === "loading") return;
    if (event.button !== 0) return;
    const target = event.target;
    if (target?.closest("[data-toast-close], [data-toast-action], button, a")) return;
    this.dragStartTime = Date.now();
    this.pointerStart = {
      x: event.clientX,
      y: event.clientY
    };
    this.swipeAxis = null;
    this.setPointerCapture(event.pointerId);
  }
  onPointerMove(event) {
    if (!this.pointerStart) return;
    const {
      y,
      x
    } = splitToastPosition(this.position);
    const deltaX = event.clientX - this.pointerStart.x;
    const deltaY = event.clientY - this.pointerStart.y;
    if (!this.swiping) {
      if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) return;
      this.swiping = true;
      this.syncDomState();
    }
    if (!this.swipeAxis) {
      this.swipeAxis = Math.abs(deltaX) > Math.abs(deltaY) ? "x" : "y";
    }
    const swipeAmountX = this.swipeAxis === "x" ? deltaX : 0;
    const swipeAmountY = this.swipeAxis === "y" ? deltaY : 0;
    if (this.swipeAxis === "y") {
      const towardExit = y === "bottom" ? swipeAmountY > 0 : swipeAmountY < 0;
      if (!towardExit && Math.abs(swipeAmountY) < TOAST_SWIPE_THRESHOLD) {
        this.style.setProperty("--swipe-amount-x", "0px");
        this.style.setProperty("--swipe-amount-y", "0px");
        return;
      }
    }
    if (this.swipeAxis === "x") {
      const towardExit = x === "start" ? swipeAmountX < 0 : swipeAmountX > 0;
      if (x !== "center" && !towardExit && Math.abs(swipeAmountX) < TOAST_SWIPE_THRESHOLD) {
        this.style.setProperty("--swipe-amount-x", "0px");
        this.style.setProperty("--swipe-amount-y", "0px");
        return;
      }
    }
    this.style.setProperty("--swipe-amount-x", `${swipeAmountX}px`);
    this.style.setProperty("--swipe-amount-y", `${swipeAmountY}px`);
  }
  onPointerUp(event) {
    if (!this.pointerStart) return;
    try {
      this.releasePointerCapture(event.pointerId);
    } catch {}
    const wasSwiping = this.swiping;
    this.swiping = false;
    if (!wasSwiping) {
      this.pointerStart = null;
      this.dragStartTime = null;
      this.swipeAxis = null;
      return;
    }
    const swipeAmountX = Number.parseFloat(this.style.getPropertyValue("--swipe-amount-x") || "0");
    const swipeAmountY = Number.parseFloat(this.style.getPropertyValue("--swipe-amount-y") || "0");
    const swipeAmount = this.swipeAxis === "x" ? swipeAmountX : swipeAmountY;
    const swipeTime = this.dragStartTime ? Date.now() - this.dragStartTime : 0;
    const velocity = Math.abs(swipeAmount) / Math.max(swipeTime, 1);
    const shouldDismiss = Math.abs(swipeAmount) >= TOAST_SWIPE_THRESHOLD || velocity > 0.11;
    if (shouldDismiss && this.dismissible) {
      const {
        y,
        x
      } = splitToastPosition(this.position);
      if (this.swipeAxis === "x") {
        this.swipeOutDirection = swipeAmountX < 0 ? "left" : "right";
        if (x === "start") this.swipeOutDirection = "left";
        if (x === "end") this.swipeOutDirection = "right";
      } else {
        this.swipeOutDirection = y === "bottom" ? "down" : "up";
      }
      this.swipeOut = true;
      this.syncDomState();
      this.beginRemove();
    } else {
      this.style.setProperty("--swipe-amount-x", "0px");
      this.style.setProperty("--swipe-amount-y", "0px");
      this.swipeAxis = null;
      this.syncDomState();
    }
    this.pointerStart = null;
    this.dragStartTime = null;
  }
  onCloseClick(event) {
    event.stopPropagation();
    if (!this.dismissible) return;
    this.beginRemove();
  }
  onActionClick(event) {
    event.stopPropagation();
    const record = toastState.getSnapshot().find(toast => toast.id === this.resolvedId);
    record?.action?.onClick(event);
    if (this.dismissible) this.beginRemove();
  }
  syncDomState() {
    const {
      y,
      x
    } = splitToastPosition(this.position);
    this.setAttribute("role", "listitem");
    this.dataset.mounted = String(this.mounted);
    this.dataset.removed = String(this.removed);
    this.dataset.swiping = String(this.swiping);
    this.dataset.swipeOut = String(this.swipeOut);
    this.dataset.dismissible = String(this.dismissible);
    this.dataset.yPosition = y;
    this.dataset.xPosition = x;
    this.dataset.variant = this.variant ?? "default";
    if (this.swipeOutDirection) this.dataset.swipeDirection = this.swipeOutDirection;else delete this.dataset.swipeDirection;
  }
  iconForVariant() {
    switch (this.variant) {
      case "success":
        return "\u2713";
      case "error":
        return "\u2715";
      case "warning":
        return "!";
      case "info":
        return "i";
      default:
        return "";
    }
  }
  render() {
    const variant = this.variant ?? "default";
    const icon = this.iconForVariant();
    const showIcon = variant !== "default";
    return /* @__PURE__ */jsxs("div", {
      ref: "toast",
      class: `rui-toast rui-toast--${variant}`,
      role: "status",
      "aria-live": "off",
      "data-ref": "toast",
      children: [this.closeButton && variant !== "loading" ? /* @__PURE__ */jsx("button", {
        type: "button",
        class: "rui-toast__close",
        "data-toast-close": true,
        "aria-label": "Close toast",
        children: "\xD7"
      }) : null, showIcon ? /* @__PURE__ */jsx("span", {
        class: "rui-toast__icon",
        "data-icon": true,
        "aria-hidden": "true",
        children: variant === "loading" ? /* @__PURE__ */jsx("span", {
          class: "rui-toast__loader"
        }) : icon
      }) : null, /* @__PURE__ */jsxs("div", {
        class: "rui-toast__content",
        children: [/* @__PURE__ */jsx("div", {
          class: "rui-toast__title",
          "data-title": true,
          children: this.$.title
        }), this.description ? /* @__PURE__ */jsx("div", {
          class: "rui-toast__description",
          "data-description": true,
          children: this.$.description
        }) : null]
      }), this.actionLabel ? /* @__PURE__ */jsx("button", {
        type: "button",
        class: "rui-toast__action rui-button rui-button--outline rui-button--sm",
        "data-toast-action": true,
        children: this.$.actionLabel
      }) : null]
    });
  }
  static {
    _initClass();
  }
}
export { _RuiToast as RuiToast };